import React, { useEffect, useState } from 'react'
import { Radio, Button, Checkbox, Input, Select, Modal } from 'antd'
import MqttServer from '@/utils/mqttUtil'
import useGlobalConfigStore from '@/stores/globalConfig'
import useMessage from '@/hooks/useMessage'
import { addCommLog, updateCommLog } from '@/api/powerStation'
import { getDeviceData } from '@/utils/getData'

const SettingPage: React.FC<{ groupData: any[]; groupName: string; uuid: string; id: number; mqtt: MqttServer }> = ({
  groupData,
  groupName,
  uuid,
  id,
  mqtt,
}) => {
  // console.log(groupData, groupName)

  const battTypeOption = [
    { name: 'Lithium Battery', value: 0 },
    { name: 'Batt-V', value: 1 },
    { name: 'Batt-%', value: 2 },
    { name: 'No Battery', value: 3 },
  ]

  const [groupDataState, setGroupDataState] = useState<any[]>([])
  useEffect(() => {
    setGroupDataState(groupData)
  }, [groupData])

  const setLoading = useGlobalConfigStore(state => state.setLoading)
  const { message } = useMessage()
  const [battType, setBattType] = useState<number>(0)
  const [open, setOpen] = useState<boolean>(false)
  const [confirmLoading, setConfirmLoading] = useState<boolean>(false)
  const [loaded, setLoaded] = useState<boolean>(false)

  let controlMode = 0,
    batteryOperateds = 0,
    o_battType = 0
  const battTypeOnChange = ({ target: { value } }: any) => {
    dataFilter(groupData, value)
  }

  const hiddenList: { [key: string]: boolean } = {
    FW: false,
    VW: false,
    VQ: false,
    PQ: false,
    PPF: false,
    LHVRT: false,
    LB: true,
    BV: true,
    BB: true,
    NB: true,
    GI: false,
    SO: false,
    MI: false,
    EMFCT: false,
    DC: false,
  }
  const dataFilter = (groupD: any[], battT: number) => {
    var groupDataTemp: any[] = []
    if (groupName === 'Battery Setting') {
      let attached = ''
      if (battT === 0) {
        controlMode = 1
        batteryOperateds = 1
        attached = 'LB'
      } else if (battT === 1) {
        controlMode = 0
        batteryOperateds = 0
        attached = 'BV'
      } else if (battT === 2) {
        controlMode = 0
        batteryOperateds = 1
        attached = 'BB'
      } else if (battT === 3) {
        batteryOperateds = 2
        attached = 'NB'
      }
      const groupDataTemp = groupD.map(item => {
        item.hidden = !(item.attached === undefined || item.attached.includes(attached))
        return item
      })
      const genSignalTemp = groupDataTemp.find(item => item.fun_code === 'Gen_Grid_Signal_On')
      if (genSignalTemp) {
        if (genSignalTemp.value == '0') {
          genSignalTemp.gridSignal = '1'
          genSignalTemp.genSignal = '1'
        } else if (genSignalTemp.value == '1') {
          genSignalTemp.gridSignal = '0'
          genSignalTemp.genSignal = '1'
        } else if (genSignalTemp.value == '2') {
          genSignalTemp.gridSignal = '1'
          genSignalTemp.genSignal = '0'
        } else if (genSignalTemp.value == '3') {
          genSignalTemp.gridSignal = '0'
          genSignalTemp.genSignal = '0'
        }
        if (genSignalTemp.hidden || genSignalTemp.value == 0 || genSignalTemp.value == 1) {
          groupDataTemp.find(rp => rp.fun_code === 'Force_on_generator_as_load_function').hidden = true
        } else {
          groupDataTemp.find(rp => rp.fun_code === 'Force_on_generator_as_load_function').hidden = false
        }
      }
      setGroupDataState(groupDataTemp)
      // console.log(groupDataTemp)
    } else if (groupName === 'System Mode') {
      let touTemp = false
      groupDataTemp = groupD.map(data => {
        if (data.battV !== undefined && !touTemp) {
          data.hidden = battT == 1 ? !data.battV : data.battV
        } else if (data.fun_code === 'Time_of_Use_Selling_enabled') {
          if (battT == 3) {
            data.hidden = true
            touTemp = true
          } else {
            touTemp = data.value == 0
          }
        } else {
          data.hidden = touTemp
        }
        return data
      })
      setGroupDataState(groupDataTemp)
    } else if (groupName === 'Grid Setting') {
      const gridTypeTemp = groupD.find(rp => rp.fun_code === 'Grid_type')
      if (gridTypeTemp) {
        var tvalue
        if (gridTypeTemp.value === undefined) {
          tvalue = undefined
        } else {
          groupD.find(rp => rp.fun_code === 'Microinverter_export_to_grid_cutoff').type_value = Number(
            gridTypeTemp.value
          )
        }
      }
      var tempList = groupD.find(rp => rp.fun_name === 'F(W)')
      hiddenList.FW = tempList.type_detail.find((item: any) => item.value == tempList.value)?.name == 'Disable'
      tempList = groupD.find(rp => rp.fun_name === 'V(W)')
      hiddenList.VW = tempList.type_detail.find((item: any) => item.value == tempList.value)?.name == 'Disable'
      tempList = groupD.find(rp => rp.fun_name === 'V(Q)')
      hiddenList.VQ = tempList.type_detail.find((item: any) => item.value == tempList.value)?.name == 'Disable'
      tempList = groupD.find(rp => rp.fun_name === 'P(Q)')
      hiddenList.PQ = tempList.type_detail.find((item: any) => item.value == tempList.value)?.name == 'Disable'
      tempList = groupD.find(rp => rp.fun_name === 'P(PF)')
      hiddenList.PPF = tempList.type_detail.find((item: any) => item.value == tempList.value)?.name == 'Disable'
      groupDataTemp = groupD.map(rp => {
        if (rp.attached) {
          rp.hidden = hiddenList[rp.attached as string]
        }
        return rp
      })
      setGroupDataState(groupDataTemp)
    } else if (groupName === 'SmartLoad') {
      const smartLoadSetup = groupD.find(data => data.fun_name === 'SmartLoad Setup').value
      if (smartLoadSetup == 0) {
        hiddenList.GI = false
        hiddenList.SO = true
        hiddenList.MI = true
      } else if (smartLoadSetup == 1) {
        hiddenList.GI = true
        hiddenList.SO = false
        hiddenList.MI = true
      } else if (smartLoadSetup == 2) {
        hiddenList.GI = true
        hiddenList.SO = true
        hiddenList.MI = false
      }
      groupDataTemp = groupD.map(data => {
        if (data.attached) {
          var hidden = true
          for (var i = 0; i < data.attached.length; i++) {
            hidden = hiddenList[data.attached[i]]
            if (!hidden) {
              break
            }
          }
          data.hidden = hidden
        }
        return data
      })
      setGroupDataState(groupDataTemp)
    } else if (groupName === 'Advanced Setting') {
      hiddenList.EMFCT = groupD.find(data => data.fun_code === 'Ex_MeterCT').value == 0
      hiddenList.DC =
        groupD.find(data => data.fun_name === 'DC 1 for WindTurbine').value == 0 &&
        groupD.find(data => data.fun_name === 'DC 2 for WindTurbine').value == 0
      groupDataTemp = groupD.map(data => {
        if (data.attached) {
          data.hidden = hiddenList[data.attached]
        }
        return data
      })
      setGroupDataState(groupDataTemp)
    }
    setBattType(battT)
  }

  const read = async () => {
    let comm_id: any,
      commReturnData = []
    setLoading(true)
    try {
      const logParams = {
        device_id: id,
        module_title: groupName,
        read_set: 'Read',
        funs: '',
      }
      let res: any = await addCommLog(logParams)
      if (res.code == 1001) {
        comm_id = res.data.comm_id
      } else {
        throw new Error('Add Comm_Log Failed')
      }
    } catch (e) {
      console.log(e)
      setLoading(false)
      message.error('Add Comm_Log Failed')
    }

    try {
      let res: any,
        params = [],
        battT = battType

      if (groupName === 'Battery Setting' || groupName === 'System Mode') {
        res = await getDeviceData(
          [{ device_id: id, defines: ['Control_Mode', 'battery_operates_according_to_voltage_or_capacity'] }],
          mqtt,
          uuid
        )
        // console.log(res)
        controlMode = res.data[0].datas.find((item: any) => item.property_code === 'Control_Mode').value
        batteryOperateds = res.data[0].datas.find(
          (item: any) => item.property_code === 'battery_operates_according_to_voltage_or_capacity'
        ).value
        if (controlMode == 1 && batteryOperateds == 1) {
          o_battType = battT = 0
        } else if (controlMode == 0 && batteryOperateds == 0) {
          o_battType = battT = 1
        } else if (controlMode == 0 && batteryOperateds == 1) {
          o_battType = battT = 2
        } else if (batteryOperateds == 2) {
          o_battType = battT = 3
        }
        commReturnData.push({
          title: 'Batt Type',
          value: battTypeOption.find(option => option.value === battType)?.name,
          unit: '',
        })
      }
      params = [
        {
          device_id: id,
          defines: groupData.filter((item: any) => item.fun_code).map((item: any) => item.fun_code) as string[],
        },
      ]
      res = await getDeviceData(params, mqtt, uuid)
      // console.log(res)
      const groupDataTemp = [...groupData]
      res.data[0].datas.map((item: any) => {
        const target = groupDataTemp.find((i: any) => i.fun_code === item.property_code)
        if (target) {
          target.value = item.value
          if (target.fun_name) {
            commReturnData.push({
              title: target.fun_name,
              value: item.value,
              unit: target.unit,
            })
          } else if (target.fun_code === 'Gen_Grid_Signal_On') {
            commReturnData.push({
              title: 'Grid Signal',
              value: target.gridSignal,
              unit: '',
            })
            commReturnData.push({
              title: 'Gen Signal',
              value: target.genSignal,
              unit: '',
            })
          }
        }
      })
      const funArrays = groupData.filter((item: any) => item.fun_array)
      if (funArrays.length > 0) {
        for (const item of funArrays) {
          params[0].defines = item.fun_array.map((e: any) => e.fun_code)
          if (params[0].defines.length > 0) {
            res = await getDeviceData(params, mqtt, uuid)
            if (res.code == 1) {
              let data = res.data[0].datas
              const value: string[] = []
              item.fun_array.forEach((fun: any) => {
                const target = data.find((e: any) => e.property_code === fun.fun_code)
                if (target) {
                  fun.value = target.value
                  if (fun.value == 1) {
                    value.push(fun.fun_name)
                  }
                }
              })
              commReturnData.push({
                title: item.fun_name,
                value,
                unit: item.unit,
              })
            }
          }
        }
      }
      dataFilter(groupDataTemp, battT)

      // debug
      // setLoading(false)
      // setLoaded(true)
    } catch (e) {
      console.log(e)
      setLoading(false)
      message.error('Read Data Failed')
    }

    try {
      const updateCommParams = {
        comm_id,
        funs: JSON.stringify(commReturnData),
      }
      const res: any = await updateCommLog(updateCommParams)
      if (res.code != 1001) {
        throw new Error('Update Comm Log Failed')
      }
      setLoading(false)
      setLoaded(true)
    } catch (e) {
      console.log(e)
      setLoading(false)
      message.error('Update Comm Log Failed')
    }
  }

  const setDevice = (funCode: string, value: string | number) => {
    return new Promise((resolve, reject) => {
      mqtt
        .set(uuid, id, funCode, value)
        .then(res => {
          resolve(res)
        })
        .catch(e => {
          reject(e)
        })
    })
  }

  const addSetLog = async () => {
    let res: any, comm_id

    const logParams: any = {
      device_id: id,
      module_title: groupName,
      read_set: 'Set',
      funs: [],
    }
    if (groupName === 'Battery Setting') {
      if (o_battType !== battType) {
        logParams.funs.push({
          title: 'Batt Type',
          value: battTypeOption.find(option => option.value === battType)?.name,
          unit: '',
        })
      }
    }
    groupDataState.forEach(data => {
      if (!data.hidden && data.fun_code && data.value && (data.o_value === undefined || data.o_value !== data.value)) {
        if (data.fun_name) {
          logParams.funs.push({
            title: data.fun_name,
            value: data.value,
            unit: data.unit,
          })
        } else if (data.fun_code === 'Gen_Grid_Signal_On') {
          logParams.funs.push({
            title: 'Grid Signal',
            value: data.gridSignal,
            unit: '',
          })
          logParams.funs.push({
            title: 'Gen Signal',
            value: data.genSignal,
            unit: '',
          })
        }
      } else if (data.fun_array) {
        const value = []
        var flag = false
        for (let fun of data.fun_array) {
          if (fun.value == 1) {
            value.push(fun.fun_name)
          }
          if (!fun.o_value || (fun.o_value && fun.value !== fun.o_value)) {
            flag = true
          }
        }
        if (flag) {
          logParams.funs.push({
            title: data.fun_name,
            value,
            unit: '',
          })
        }
      }
    })
    logParams.funs = JSON.stringify(logParams.funs)
    // console.log(logParams)
    try {
      res = await addCommLog(logParams)
      // console.log(res)
      if (res.code == 1001) {
        comm_id = res.data.comm_id
      }
    } catch (e) {
      console.log(e)
    }
    if (comm_id) {
      return { logParams, comm_id }
    }
  }

  const updateSetLog = async (logParams: any, comm_id: any) => {
    try {
      // console.log(logParams, comm_id)
      let res: any = await updateCommLog({ comm_id, funs: logParams })
      // console.log(res)
    } catch (e) {
      console.log(e)
    }
  }

  const set = async () => {
    const logInform: any = await addSetLog()
    if (groupName === 'Battery Setting') {
      if (battType !== o_battType) {
        const res1 = await setDevice('Control_Mode', controlMode)
        const res2 = await setDevice('battery_operates_according_to_voltage_or_capacity', batteryOperateds)
        o_battType = battType
      }
    }
    for (let data of groupDataState) {
      if (data.hidden) {
        continue
      }
      if (data.fun_code && data.value && (data.o_value === undefined || data.o_value !== data.value)) {
        if (data.offset && Number(data.value) > data.offset) {
          data.value = Number(data.value - data.offset).toString()
        }
        // console.log(data)
        const res = await setDevice(data.fun_code, data.value)
        data.o_value = data.value
      } else if (data.fun_array) {
        for (let fun of data.fun_array) {
          if (!fun.o_value || (fun.o_value && fun.value !== fun.o_value)) {
            // console.log(data)
            const res = await setDevice(fun.fun_code, fun.value)
            fun.o_value = fun.value
          }
        }
      }
    }
    await updateSetLog(logInform.logParams, logInform.comm_id)
    setConfirmLoading(false)
    setOpen(false)
  }

  const submit = () => {
    setOpen(true)
  }

  const handleOk = () => {
    setConfirmLoading(true)
    set()
  }

  const onChange = (value: string, index: number, filter: boolean | undefined) => {
    const groupDataStateTemp = [...groupDataState]
    groupDataStateTemp[index].value = value
    // console.log(groupDataStateTemp)
    if (filter) {
      dataFilter(groupDataStateTemp, battType)
    } else {
      setGroupDataState(groupDataStateTemp)
    }
  }

  const onChangeSignal = (value: string, index: number, key: string) => {
    const groupDataStateTemp = [...groupDataState]
    const target = groupDataStateTemp[index]
    target[key] = value
    if (target.gridSignal == '1' && target.genSignal == '1') {
      target.value = '0'
    } else if (target.gridSignal == '0' && target.genSignal == '1') {
      target.value = '1'
    } else if (target.gridSignal == '1' && target.genSignal == '0') {
      target.value = '2'
    } else if (target.gridSignal == '0' && target.genSignal == '0') {
      target.value = '3'
    }
    dataFilter(groupDataStateTemp, battType)
  }

  const onChangeFunArray = (value: string, index: number, fun_index: number) => {
    const groupDataStateTemp = [...groupDataState]
    const target = groupDataStateTemp[index]
    target.fun_array[fun_index].value = value
    setGroupDataState(groupDataStateTemp)
  }

  return (
    <div className='settingPage'>
      <div className='dataPlace'>
        {groupName === 'Battery Setting' && (
          <div className='batterySetting'>
            <span>Batt Type</span>
            <Radio.Group onChange={battTypeOnChange} value={battType} style={{ marginLeft: '20px' }}>
              <Radio value={0}>Lithium Battery</Radio>
              <Radio value={1}>Batt-V</Radio>
              <Radio value={2}>Batt-%</Radio>
              <Radio value={3}>No Battery</Radio>
            </Radio.Group>
          </div>
        )}
        {groupDataState.map((item, index) => {
          if (!item.hidden) {
            if (item.fun_code === 'Gen_Grid_Signal_On') {
              return (
                <template key={item.fun_code}>
                  <div style={{ width: '100%', height: '0' }} />
                  {/* <div style={{ width: "100%", display: "flex", alignItems: "center" }} key={item.fun_code}> */}
                  <div className='one_item'>
                    <div className='fun_name'>Grid Signal</div>
                    <Radio.Group
                      value={item.gridSignal}
                      onChange={e => onChangeSignal(e.target.value, index, 'gridSignal')}>
                      {item.type_detail.map((detail: any) => (
                        <Radio.Button value={detail.value} key={detail.value}>
                          {detail.name}
                        </Radio.Button>
                      ))}
                    </Radio.Group>
                  </div>
                  <div className='one_item'>
                    <div className='fun_name'>Gen Signal</div>
                    <Radio.Group
                      value={item.genSignal}
                      onChange={e => onChangeSignal(e.target.value, index, 'genSignal')}>
                      {item.type_detail.map((detail: any) => (
                        <Radio.Button value={detail.value} key={detail.value}>
                          {detail.name}
                        </Radio.Button>
                      ))}
                    </Radio.Group>
                  </div>
                  {/* </div> */}
                </template>
              )
            } else if (item.title) {
              return (
                <div className='fun_title' key={item.title === true ? 'title' + index : item.title}>
                  {item.title !== true && (
                    <span
                      style={{
                        height: '70px',
                        padding: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        fontWeight: 'bold',
                        fontSize: '18px',
                      }}>
                      {item.title}
                    </span>
                  )}
                </div>
              )
            } else if (item.fun_array && item.fun_array.length > 0) {
              return (
                <div key={item.fun_name} style={{ width: '100%', padding: '10px' }}>
                  <div
                    style={{
                      height: '30px',
                      display: 'flex',
                      alignItems: 'center',
                      fontWeight: 'bold',
                      fontSize: '18px',
                    }}>
                    {item.fun_name}
                  </div>
                  <div style={{ height: '70px', display: 'flex', alignItems: 'center' }}>
                    {item.fun_array.map(
                      (fun: { fun_code: string; fun_name: string; value: string }, fun_index: number) => (
                        <Checkbox
                          key={fun.fun_code}
                          checked={fun.value === '1'}
                          onChange={e => onChangeFunArray(e.target.value, index, fun_index)}>
                          {fun.fun_name}
                        </Checkbox>
                      )
                    )}
                  </div>
                </div>
              )
            } else {
              return (
                <div className='one_item' key={item.fun_code + item.fun_name + index}>
                  <div className='fun_name'>{item.fun_name}</div>
                  {item.type === 'value' && (
                    <Input
                      value={item.value}
                      style={{ width: '50%' }}
                      onChange={e => onChange(e.target.value, index, item.filter)}
                    />
                  )}
                  {item.type === 'option' && item.type_detail.length <= 2 && (
                    <Radio.Group value={item.value} onChange={e => onChange(e.target.value, index, item.filter)}>
                      {item.type_detail.map((detail: any) => (
                        <Radio.Button value={detail.value} key={detail.name}>
                          {detail.name}
                        </Radio.Button>
                      ))}
                    </Radio.Group>
                  )}
                  {item.type === 'option' && item.type_detail.length > 2 && (
                    <Select
                      value={item.value}
                      style={{ width: '50%' }}
                      options={item.type_detail.map((detail: any) => ({ value: detail.value, label: detail.name }))}
                      onChange={e => onChange(e, index, item.filter)}
                    />
                  )}
                  {item.type === 'Doption' && (
                    <Select
                      value={item.value}
                      style={{ width: '50%' }}
                      options={item.type_detail[item.type_value].map((detail: any) => ({
                        value: detail.value,
                        label: detail.name,
                      }))}
                      onChange={e => onChange(e, index, item.filter)}
                    />
                  )}
                </div>
              )
            }
          }
        })}
      </div>
      <div className='btnPlace'>
        {loaded && (
          <Button type='primary' onClick={submit}>
            Submit
          </Button>
        )}
        <Button type='primary' onClick={read} style={{ marginLeft: '20px' }}>
          Read
        </Button>
        <Modal
          title='Are you confirm to submit?'
          open={open}
          onOk={handleOk}
          confirmLoading={confirmLoading}
          onCancel={() => setOpen(false)}
        />
      </div>
      {/* <div className="BatterySetting__title">
        Battery mode
        <Tooltip placement="right" title="prompt text">
          <img src="/assets/image/info.svg" alt="info" />
        </Tooltip>
      </div>
      <div className="BatterySetting__content">
        <div className="BatterySetting__content__model">
          {plainOptions.map((option) => (
            <Checkbox
              key={option.value}
              checked={checkedValue === option.value}
              onChange={(e) => onChange(e, option.value)}
            >
              {option.label}
            </Checkbox>
          ))}
        </div>
        <div>
          <SettingFrom index={checkedValue} />
        </div>
      </div> */}
    </div>
  )
}

export default SettingPage
